export default __webpack_public_path__ + "static/media/icons-matamask-white.168fcd7d.svg";